<template>
  <section class="apple-ui-setting-group" :aria-labelledby="headingId">
    <h2 :id="headingId" class="apple-ui-setting-group-title">{{ title }}</h2>
    <div class="apple-ui-setting-group-rows"><slot /></div>
    <p v-if="description" class="apple-ui-setting-group-description">{{ description }}</p>
  </section>
</template>
<script>
export default {
  name: 'AppleSettingGroup',
  props: { title: { type: String, required: true }, description: { type: String, default: '' } },
  computed: { headingId() { return `apple-setting-group-${this._uid}`; } },
};
</script>
<style scoped>
.apple-ui-setting-group { min-width:0; }
.apple-ui-setting-group-title { margin:0 0 8px; color:var(--apple-ui-text,var(--color-text)); font-size:14px; line-height:1.4; letter-spacing:-.01em; font-weight:600; }
.apple-ui-setting-group-rows { min-width:0; padding:0 14px; border:1px solid var(--apple-ui-border,var(--apple-border)); border-radius:var(--apple-ui-radius-group,10px); background:var(--apple-ui-surface-raised,var(--color-secondary-bg)); }
.apple-ui-setting-group-rows ::v-deep > .apple-ui-setting-row + .apple-ui-setting-row { border-top:1px solid var(--apple-ui-border,var(--apple-border)); }
.apple-ui-setting-group-description { margin:7px 14px 0; color:var(--apple-ui-muted,var(--color-secondary)); font-size:12px; line-height:1.5; overflow-wrap:anywhere; }
</style>
